/**
 * Product Variants Functionality
 * Shared between main-product.liquid and main-product-form.liquid
 */
(function() {
  'use strict';

  function initProductVariants(productData, currentVariant) {
    if (!productData || !window.productForm) return;

    const productForm = document.querySelector('.form');
    if (!productForm) return;

    // VARIANT HANDLING
    const radios = document.querySelectorAll('.variant-selector input[type="radio"]');

    // Auto-select first available if only 1 option
    if (productData.options.length === 1) {
      const firstAvailable = productData.variants.find(v => v.available);
      if (firstAvailable) {
        updateVariant(firstAvailable);
        document.querySelectorAll('.variant-option input').forEach(input => {
          const isAvailable = productData.variants.some(v => v.available && v.options[0] === input.value);
          !isAvailable ? input.classList.add("disabled") : input.classList.remove("disabled");

          if (firstAvailable.options[0] === input.value) input.checked = true;
        });
      }
    }

    radios.forEach(radio => {
      radio.addEventListener('change', function() {
        const selectedOptions = getSelectedOptions();
        const selectedVariant = findVariantByOptions(selectedOptions);
        if (selectedVariant) updateVariant(selectedVariant);
        updateOptionAvailability(selectedOptions);
      });
    });

    function updateOptionAvailability(selectedOptions) {
      productData.options.forEach((optionName, optionIndex) => {
        const groupInputs = document.querySelectorAll(`.variant-option:nth-child(${optionIndex+1}) input`);
        groupInputs.forEach(input => {
          const isPossible = productData.variants.some(variant => {
            if (!variant.available) return false;
            return variant.options.every((opt, idx) => {
              if (idx === optionIndex) return opt === input.value;
              return !selectedOptions[idx] || selectedOptions[idx] === opt;
            });
          });
          !isPossible ? input.classList.add("disabled") : input.classList.remove("disabled");
        });
      });
    }

    function getSelectedOptions() {
      const selectedOptions = [];
      document.querySelectorAll('.variant-option').forEach(group => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const labels = group.querySelectorAll('.option-value');
        labels.forEach(label => label.classList.remove('selected'));
        if (checked) {
          selectedOptions.push(checked.value);
          const checkedLabel = group.querySelector(`label[for="${checked.id}"]`);
          if (checkedLabel) checkedLabel.classList.add('selected');
        } else {
          selectedOptions.push(null);
        }
      });
      return selectedOptions;
    }

    function findVariantByOptions(options) {
      return productData.variants.find(variant => {
        return variant.options.every((opt, idx) => !options[idx] || options[idx] === opt);
      });
    }

    function updateVariant(variant) {
      window.history.replaceState(null, null, `?variant=${variant.id}`);
      productForm.querySelector('[name="id"]').value = variant.id;
      updatePrices(variant);
      updateAvailability(variant);

      // Fix image handling
      const firstImageEl = document.querySelector('.variant-dynamic-image');
      if (firstImageEl) {
        if (variant.featured_media) {
          firstImageEl.src = variant.featured_media.preview_image.src;
          firstImageEl.alt = variant.featured_media.alt || '';
        } else if (productData.featured_media) {
          firstImageEl.src = productData.featured_media.preview_image.src;
          firstImageEl.alt = productData.featured_media.alt || '';
        }
      }
    }

    function updatePrices(variant) {
      const currentPrice = document.querySelector('.current-price');
      const comparePrice = document.querySelector('.compare-price');
      const savings = document.querySelector(".savings");
      if (!currentPrice || !comparePrice) return;
      currentPrice.textContent = Shopify.formatMoney(variant.price, window.money_without_trailing_zeros_format);
      if (variant.compare_at_price > variant.price) {
        comparePrice.textContent = Shopify.formatMoney(variant.compare_at_price, window.money_without_trailing_zeros_format);
        const saveValue = 100 - ((variant.price / variant.compare_at_price) * 100);
        savings.textContent = `${Math.round(saveValue)}% SAVED`;
        comparePrice.style.display = 'inline';
        savings.style.display = 'inline';
      } else {
        comparePrice.style.display = 'none';
        savings.style.display = 'none';
      }
    }

    function updateAvailability(variant) {
      const addToCartBtn = document.querySelector('.product-page .add-to-cart-btn');
      const quantitySelector = document.querySelector(".quantity-selector");
      const selectedValueElements = document.querySelectorAll(".selected-value");
      if (variant && variant.options) {
        variant.options.forEach((opt, idx) => {
          if (selectedValueElements[idx]) {
            selectedValueElements[idx].textContent = opt;
          }
        });
      }
      if (variant.available) {
        if (quantitySelector) quantitySelector.style.display = 'flex';
        if (addToCartBtn) {
          addToCartBtn.innerHTML = `<span class="svg_wrapper-small">${window.bagSvg || ''}</span>Add To Bag`;
          addToCartBtn.disabled = false;
        }
      } else {
        if (quantitySelector) quantitySelector.style.display = 'none';
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = window.soldOutText || "Sold Out";
        }
      }
    }

    function checkUrlVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        const variant = productData.variants.find(v => v.id == variantId);
        if (variant) updateVariant(variant);
      } else {
        updateVariant(currentVariant);
      }
      updateOptionAvailability(getSelectedOptions());
    }

    checkUrlVariant();

    // Export updateVariant for use in form submission
    window.updateVariant = updateVariant;
  }

  // Auto-initialize if data is available
  if (window.productData && window.currentVariant) {
    document.addEventListener('DOMContentLoaded', function() {
      initProductVariants(window.productData, window.currentVariant);

const stockCountdownEls = document.querySelectorAll(".stock-countdown");
if (!stockCountdownEls.length) return;

stockCountdownEls.forEach((el) => {
  const start = Date.parse(el.dataset.startDate);
  const end = Date.parse(el.dataset.endDate);

  if (!start || !end || end <= start) {
    el.style.display = "none";
    return;
  }

  function update() {
    const now = Date.now();

    if (now >= start && now < end) {
      el.style.display = "";
      el.classList.remove("stock-countdown-hidden");
    } else {
      el.style.display = "none";
    }
  }

  // run immediately
  update();

  // check every second (cheap + reliable)
  const interval = setInterval(() => {
    const now = Date.now();

    if (now >= end) {
      clearInterval(interval);
    }

    update();
  }, 1000);
});

    });
  }

  // Export for manual initialization
  window.initProductVariants = initProductVariants;
})();



